import React from 'react';
import FacultiesList from '../../components/features/studies/FacultiesList';

export default function ListeFacultesPage() {
  return (
    <div className="space-y-6 animate-fade-in">
      <div className="text-center space-y-2 max-w-3xl mx-auto px-4">
        <h1 className="font-title text-3xl sm:text-4xl font-extrabold text-acem-primary-dark">
          Liste des Établissements
        </h1>
        <p className="text-sm sm:text-base text-acem-muted">
          Retrouvez les coordonnées, adresses, emails et sites web des facultés, instituts et universités partenaires de Fès.
        </p>
      </div>

      <FacultiesList />
    </div>
  );
}
